import * as login from './login'
import * as licence from './licence'
import * as club from './club'
import * as user from './user'

// eslint-disable-next-line import/no-anonymous-default-export
export default { login, licence, club, user }
